import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

const rp = (n) => "Rp" + (n == null ? "0" : Math.round(n).toLocaleString("id-ID"));
const diff = (a, b) => (a != null && b != null ? a - b : null);

function KPI({ label, value, prev, tone, testid }) {
  const d = prev !== undefined ? diff(value, prev) : null;
  return (
    <Card data-testid={testid} className="p-4 bg-slate-900 border-slate-800">
      <div className="text-xs text-slate-400">{label}</div>
      <div className={`text-2xl font-semibold mt-1 ${tone || "text-white"}`}>{rp(value)}</div>
      {d != null && <div className={`text-xs mt-1 ${d >= 0 ? "text-emerald-400" : "text-red-400"}`}>{d >= 0 ? "▲" : "▼"} {rp(Math.abs(d))} vs sebelumnya</div>}
    </Card>
  );
}

export default function OwnerFinanceSummary() {
  const [period, setPeriod] = useState("month");
  const [d, setD] = useState(null);
  const load = async () => { try { setD((await api.get(`/finance/owner-summary?period=${period}&compare=true`)).data); } catch (e) { toast.error(apiError(e)); } };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [period]);
  if (!d) return <div className="p-6 text-slate-400">Memuat…</div>;
  const pv = d.previous || {};
  return (
    <div className="p-6" data-testid="owner-finance-summary-page">
      <div className="flex justify-between items-center mb-4">
        <div><h1 className="text-2xl font-semibold text-white">Ringkasan Keuangan Owner</h1>
          <p className="text-slate-400 text-sm">{d.period.from} s/d {d.period.to}</p></div>
        <div className="flex items-center gap-3">
          <span className={`text-xs px-2 py-1 rounded ${d.status === "FINAL" ? "bg-emerald-500/15 text-emerald-400" : "bg-amber-500/15 text-amber-400"}`}>{d.status}</span>
          <select value={period} onChange={(e) => setPeriod(e.target.value)} data-testid="ofs-period" className="bg-slate-800 border border-slate-700 rounded px-3 py-2 text-sm text-white">
            {[["today", "Hari Ini"], ["month", "Bulan Ini"], ["last_month", "Bulan Sebelumnya"], ["year", "Tahun Ini"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <KPI testid="ofs-omzet" label="Omzet" value={d.omzet} prev={pv.omzet} />
        <KPI testid="ofs-hpp" label="HPP" value={d.hpp} />
        <KPI testid="ofs-gross" label="Laba Kotor" value={d.laba_kotor} prev={pv.laba_kotor} tone="text-emerald-400" />
        <KPI testid="ofs-net" label="Laba Bersih" value={d.laba_bersih} prev={pv.laba_bersih} tone="text-emerald-400" />
        <KPI testid="ofs-opex" label="Beban Operasional" value={d.beban_operasional} />
        <KPI testid="ofs-cash" label="Kas & Bank" value={d.cash_bank} />
        <KPI testid="ofs-ar" label="Piutang Belum Cair" value={d.piutang_belum_cair} />
        <KPI testid="ofs-ap" label="Hutang Supplier" value={d.hutang_supplier} />
      </div>
      <Card className="p-4 bg-slate-900 border-slate-800 mb-4">
        <div className="text-sm font-semibold text-white mb-2">Snapshot Hari Ini ({d.snapshot_hari_ini.tanggal}) <span className="text-xs text-slate-500">· basis akuntansi (Posted)</span></div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          <div><div className="text-slate-400 text-xs">Penjualan Hari Ini</div><div className="text-white">{rp(d.snapshot_hari_ini.penjualan)}</div></div>
          <div><div className="text-slate-400 text-xs">Kas Diterima Hari Ini</div><div className="text-white">{rp(d.snapshot_hari_ini.kas_diterima)}</div></div>
          <div><div className="text-slate-400 text-xs">Order Menunggu HPP</div><div className="text-amber-400">{d.orders_waiting_hpp}</div></div>
          <div><div className="text-slate-400 text-xs">Jurnal Menunggu Posting</div><div className="text-amber-400">{d.draft_pending}</div></div>
        </div>
      </Card>
      {d.gross_margin != null && <p className="text-slate-500 text-sm">Gross Margin {d.gross_margin}% · Net Margin {d.net_margin ?? "—"}%</p>}
    </div>
  );
}
